let dirPath = 'games/page030_game0/';
let dirAudio = 'games/page030_game0/audio/';

let configGame = {
  autoCheckAllCorrect: true,
  removeInCorrects: true,
  correctBlock: false,
  rulesGame: {
    otherProperty: {
      sounds: [{ src: dirPath + 'audio/click.mp3', id: 'mouseup' }],
    },
    // itemsConfig: { shuffle: false, block: true },
    items: [
      {
        idGroup: 'source',
        idItem: 's01',
        itemsConfig: { shuffle: true, block: true },
        items: [
          {
            idGroup: 'target',
            idItem: 't01',
            correct: [{ idGroup: 'source', idItem: 's01' }],
          },
        ],
      },
      {
        idGroup: 'source',
        idItem: 's02',
        itemsConfig: { shuffle: true, block: true },
        items: [
          {
            idGroup: 'target',
            idItem: 't02',
            correct: [{ idGroup: 'source', idItem: 's02' }],
          },
        ],
      },
      {
        idGroup: 'source',
        idItem: 's03',
        itemsConfig: { shuffle: true, block: true },
        items: [
          {
            idGroup: 'target',
            idItem: 't03',
            correct: [{ idGroup: 'source', idItem: 's03' }],
          },
        ],
      },
      {
        idGroup: 'source',
        idItem: 's04',
        itemsConfig: { shuffle: true, block: true },
        items: [
          {
            idGroup: 'target',
            idItem: 't04',
            correct: [{ idGroup: 'source', idItem: 's04' }],
          },
        ],
      },
      {
        idGroup: 'source',
        idItem: 's05',
        itemsConfig: { shuffle: true, block: true },
        items: [
          {
            idGroup: 'target',
            idItem: 't05',
            correct: [{ idGroup: 'source', idItem: 's05' }],
          },
        ],
      },
      {
        idGroup: 'source',
        idItem: 's06',
        itemsConfig: { shuffle: true, block: true },
        items: [
          {
            idGroup: 'target',
            idItem: 't06',
            correct: [{ idGroup: 'source', idItem: 's06' }],
          },
        ],
      },
      {
        idGroup: 'source',
        idItem: 's07',
        itemsConfig: { shuffle: true, block: true },
        items: [
          {
            idGroup: 'target',
            idItem: 't07',
            correct: [{ idGroup: 'source', idItem: 's07' }],
          },
        ],
      },
      {
        idGroup: 'source',
        idItem: 's08',
        itemsConfig: { shuffle: true, block: true },
        items: [
          {
            idGroup: 'target',
            idItem: 't08',
            correct: [{ idGroup: 'source', idItem: 's08' }],
          },
        ],
      },
      {
        idGroup: 'source',
        idItem: 's09',
        itemsConfig: { shuffle: true, block: true },
        items: [
          {
            idGroup: 'target',
            idItem: 't09',
            correct: [{ idGroup: 'source', idItem: 's09' }],
          },
        ],
      },
      {
        idGroup: 'source',
        idItem: 's10',
        itemsConfig: { shuffle: true, block: true },
        items: [
          {
            idGroup: 'target',
            idItem: 't10',
            correct: [{ idGroup: 'source', idItem: 's10' }],
          },
        ],
      },
      {
        idGroup: 'source',
        idItem: 's11',
        itemsConfig: { shuffle: true, block: true },
        items: [
          {
            idGroup: 'target',
            idItem: 't11',
            correct: [{ idGroup: 'source', idItem: 's11' }],
          },
        ],
      },
      {
        idGroup: 'source',
        idItem: 's12',
        itemsConfig: { shuffle: true, block: true },
        items: [
          {
            idGroup: 'target',
            idItem: 't12',
            correct: [{ idGroup: 'source', idItem: 's12' }],
          },
        ],
      },
      {
        idGroup: 'source',
        idItem: 's13',
        itemsConfig: { shuffle: true, block: true },
        items: [
          {
            idGroup: 'target',
            idItem: 't13',
            correct: [{ idGroup: 'source', idItem: 's13' }],
          },
        ],
      },
      {
        idGroup: 'source',
        idItem: 's14',
        itemsConfig: { shuffle: true, block: true },
        items: [
          {
            idGroup: 'target',
            idItem: 't14',
            correct: [{ idGroup: 'source', idItem: 's14' }],
          },
        ],
      },
    ],
  },
  layout: {
    itemsConfig: {
      positions: { pos: { width: 792 }, margin: { right: 4 } },
      background: {
        text: {
          font: 'Garamond',
          size: '32px',
          textAlign: 'center',
          textBaseline: 'middle',
        },
      },
    },
    groups: [
      {
        idGroup: 'target',
        positions: {
          type: 'absolute',
          autoFit: true,
          fixTab: [
            { x: 205 + 2, y: 181 + 2 },
            { x: 205 + 2, y: 338 + 2 },
            { x: 398 + 2, y: 181 + 2 },
            { x: 398 + 2, y: 338 + 2 },
            { x: 591 + 2, y: 181 + 2 },
            { x: 591 + 2, y: 338 + 2 },
            { x: 591 + 2, y: 494 + 2 },
            { x: 591 + 2, y: 651 + 2 },
            { x: 591 + 2, y: 808 + 2 },
            { x: 784 + 2, y: 181 + 2 },
            { x: 784 + 2, y: 338 + 2 },
            { x: 784 + 2, y: 494 + 2 },
            { x: 784 + 2, y: 651 + 2 },
            { x: 784 + 2, y: 808 + 2 },
          ],
        },
        otherProperty: {
          hooks: {
            autoResize: true,
            background: { color: 'rgba(255,255,255,0.01)' },
            positions: { pos: { width: 96, height: 96 } },
            items: [{ id: 'h01' }],
          },
        },
        items: [
          {
            id: 't01',
            otherProperty: {
              audio: ['a01'],
              hooks: { background: { image: { color: 'rgba(0,0,0,0.01)' } } },
            },
          },
          {
            id: 't02',
            otherProperty: {
              audio: ['a02'],
              hooks: { background: { image: { color: 'rgba(0,0,0,0.01)' } } },
            },
          },
          {
            id: 't03',
            otherProperty: {
              audio: ['a03'],
              hooks: { background: { image: { color: 'rgba(0,0,0,0.01)' } } },
            },
          },
          {
            id: 't04',
            otherProperty: {
              audio: ['a04'],
              hooks: { background: { image: { color: 'rgba(0,0,0,0.01)' } } },
            },
          },
          {
            id: 't05',
            otherProperty: {
              audio: ['a05'],
              hooks: { background: { image: { color: 'rgba(0,0,0,0.01)' } } },
            },
          },
          {
            id: 't06',
            otherProperty: {
              audio: ['a06'],
              hooks: { background: { image: { color: 'rgba(0,0,0,0.01)' } } },
            },
          },
          {
            id: 't07',
            otherProperty: {
              audio: ['a07'],
              hooks: { background: { image: { color: 'rgba(0,0,0,0.01)' } } },
            },
          },
          {
            id: 't08',
            otherProperty: {
              audio: ['a08'],
              hooks: { background: { image: { color: 'rgba(0,0,0,0.01)' } } },
            },
          },
          {
            id: 't09',
            otherProperty: {
              audio: ['a09'],
              hooks: { background: { image: { color: 'rgba(0,0,0,0.01)' } } },
            },
          },
          {
            id: 't10',
            otherProperty: {
              audio: ['a10'],
              hooks: { background: { image: { color: 'rgba(0,0,0,0.01)' } } },
            },
          },
          {
            id: 't11',
            otherProperty: {
              audio: ['a11'],
              hooks: { background: { image: { color: 'rgba(0,0,0,0.01)' } } },
            },
          },
          {
            id: 't12',
            otherProperty: {
              audio: ['a12'],
              hooks: { background: { image: { color: 'rgba(0,0,0,0.01)' } } },
            },
          },
          {
            id: 't13',
            otherProperty: {
              audio: ['a13'],
              hooks: { background: { image: { color: 'rgba(0,0,0,0.01)' } } },
            },
          },
          {
            id: 't14',
            otherProperty: {
              audio: ['a14'],
              hooks: { background: { image: { color: 'rgba(0,0,0,0.01)' } } },
            },
          },
        ],
      },
      {
        idGroup: 'source',
        positions: {
          type: 'absolute',
          autoFit: true,
          fixTab: [
            { x: 1183, y: 166 }, // happy
            { x: 1580, y: 758 }, // sad
            { x: 1452, y: 541 }, // calm
            { x: 1139, y: 750 }, // angry
            { x: 1650, y: 400 }, // sleepy
            { x: 1224, y: 344 }, // hungry
            { x: 1000, y: 781 }, // scared
            { x: 1582, y: 170 }, // mummy
            { x: 1371, y: 212 }, // daddy
            { x: 978, y: 189 }, // sister
            { x: 1339, y: 718 }, // brother
            { x: 1557, y: 525 }, // baby
            { x: 975, y: 478 }, // grandma
            { x: 1186, y: 517 }, // grandpa
          ],
        },
        itemsConfig: {
          background: { color: 'rgba(255,255,255,0.01)' },
          positions: {
            pos: { width: 219, height: 219 },
            // rows: 1,
            // margin: { right: 38 },
          },
        },
        // positions: {
        //   type: 'absolute',
        //   pos: { x: 80, y: 920 },
        // },
        items: [
          {
            id: 's01',
            background: {
              image: { src: dirPath + 'img/car.webp', pos: { width: 177, height: 124, x: 0, y: (177 - 124) / 2 } },
            },
            positions: { pos: { width: 177, height: 177 } },
          },
          {
            id: 's02',
            background: {
              image: { src: dirPath + 'img/doll.webp', pos: { width: 112, height: 149, x: (149 - 112) / 2, y: 0 } },
            },
            positions: { pos: { width: 149, height: 149 } },
          },
          {
            id: 's03',
            background: {
              image: { src: dirPath + 'img/ball.webp', pos: { width: 114, height: 114, x: 0, y: 0 } },
            },
            positions: { pos: { width: 114, height: 114 } },
          },
          {
            id: 's04',
            background: {
              image: { src: dirPath + 'img/robot.webp', pos: { width: 106, height: 183, x: (183 - 106) / 2, y: 0 } },
            },
            positions: { pos: { width: 183, height: 183 } },
          },
          {
            id: 's05',
            background: {
              image: { src: dirPath + 'img/1.webp', pos: { width: 46, height: 110, x: (110 - 46) / 2, y: 0 } },
            },
            positions: { pos: { width: 110, height: 110 } },
          },
          {
            id: 's06',
            background: {
              image: { src: dirPath + 'img/2.webp', pos: { width: 71, height: 115, x: (115 - 71) / 2, y: 0 } },
            },
            positions: { pos: { width: 115, height: 115 } },
          },
          {
            id: 's07',
            background: {
              image: { src: dirPath + 'img/3.webp', pos: { width: 83, height: 121, x: (121 - 83) / 2, y: 0 } },
            },
            positions: { pos: { width: 121, height: 121 } },
          },
          {
            id: 's08',
            background: {
              image: { src: dirPath + 'img/sing.webp', pos: { width: 138, height: 177, x: (177 - 138) / 2, y: 0 } },
            },
            positions: { pos: { width: 177, height: 177 } },
          },
          {
            id: 's09',
            background: {
              image: { src: dirPath + 'img/catch.webp', pos: { width: 166, height: 247, x: (247 - 166) / 2, y: 0 } },
            },
            positions: { pos: { width: 247, height: 247 } },
          },
          {
            id: 's10',
            background: {
              image: { src: dirPath + 'img/clap.webp', pos: { width: 124, height: 189, x: (189 - 124) / 2, y: 0 } },
            },
            positions: { pos: { width: 189, height: 189 } },
          },
          {
            id: 's11',
            background: {
              image: { src: dirPath + 'img/dance.webp', pos: { width: 228, height: 228, x: 0, y: 0 } },
            },
            positions: { pos: { width: 228, height: 228 } },
          },
          {
            id: 's12',
            background: {
              image: { src: dirPath + 'img/run.webp', pos: { width: 105, height: 178, x: (178 - 105) / 2, y: 0 } },
            },
            positions: { pos: { width: 178, height: 178 } },
          },
          {
            id: 's13',
            background: {
              image: { src: dirPath + 'img/paint.webp', pos: { width: 202, height: 183, x: 0, y: (202 - 183) / 2 } },
            },
            positions: { pos: { width: 202, height: 202 } },
          },
          {
            id: 's14',
            background: {
              image: { src: dirPath + 'img/jump.webp', pos: { width: 169, height: 225, x: (225 - 169) / 2, y: 0 } },
            },
            positions: { pos: { width: 225, height: 225 } },
          },
        ],
      },
    ],
  },
};

let dataConfig = {
  // blockCheck: true,
  mainImage: {
    imagePath: dirPath + 'img/bcg.webp',
  },
  fullscreen: true,
  mixinEngine: 'dnd',
  mbAudioItemData: [
    {
      id: 'a01',
      src: dirAudio + '29_car.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page030_game0/img/audioOn.png', iconOff: 'games/page030_game0/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 16,
        x: -55,
      },
      width: '67px',
      height: '67px',
      unit: 'px',
    },
    {
      id: 'a02',
      src: dirAudio + '30_doll.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page030_game0/img/audioOn.png', iconOff: 'games/page030_game0/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 16,
        x: -55,
      },
      width: '67px',
      height: '67px',
      unit: 'px',
    },
    {
      id: 'a03',
      src: dirAudio + '31_ball_.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page030_game0/img/audioOn.png', iconOff: 'games/page030_game0/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 16,
        x: -55,
      },
      width: '67px',
      height: '67px',
      unit: 'px',
    },
    {
      id: 'a04',
      src: dirAudio + '32_robot.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page030_game0/img/audioOn.png', iconOff: 'games/page030_game0/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 16,
        x: -55,
      },
      width: '67px',
      height: '67px',
      unit: 'px',
    },
    {
      id: 'a05',
      src: dirAudio + '33_one.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page030_game0/img/audioOn.png', iconOff: 'games/page030_game0/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 16,
        x: -55,
      },
      width: '67px',
      height: '67px',
      unit: 'px',
    },
    {
      id: 'a06',
      src: dirAudio + '34_two.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page030_game0/img/audioOn.png', iconOff: 'games/page030_game0/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 16,
        x: -55,
      },
      width: '67px',
      height: '67px',
      unit: 'px',
    },
    {
      id: 'a07',
      src: dirAudio + '35_three.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page030_game0/img/audioOn.png', iconOff: 'games/page030_game0/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 16,
        x: -55,
      },
      width: '67px',
      height: '67px',
      unit: 'px',
    },
    {
      id: 'a08',
      src: dirAudio + '36_sing.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page030_game0/img/audioOn.png', iconOff: 'games/page030_game0/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 16,
        x: -55,
      },
      width: '67px',
      height: '67px',
      unit: 'px',
    },
    {
      id: 'a09',
      src: dirAudio + '37_catch.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page030_game0/img/audioOn.png', iconOff: 'games/page030_game0/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 16,
        x: -55,
      },
      width: '67px',
      height: '67px',
      unit: 'px',
    },
    {
      id: 'a10',
      src: dirAudio + '38_clap.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page030_game0/img/audioOn.png', iconOff: 'games/page030_game0/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 16,
        x: -55,
      },
      width: '67px',
      height: '67px',
      unit: 'px',
    },
    {
      id: 'a11',
      src: dirAudio + '39_dance.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page030_game0/img/audioOn.png', iconOff: 'games/page030_game0/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 16,
        x: -55,
      },
      width: '67px',
      height: '67px',
      unit: 'px',
    },
    {
      id: 'a12',
      src: dirAudio + '40_run.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page030_game0/img/audioOn.png', iconOff: 'games/page030_game0/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 16,
        x: -55,
      },
      width: '67px',
      height: '67px',
      unit: 'px',
    },
    {
      id: 'a13',
      src: dirAudio + '41_paint.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page030_game0/img/audioOn.png', iconOff: 'games/page030_game0/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 16,
        x: -55,
      },
      width: '67px',
      height: '67px',
      unit: 'px',
    },
    {
      id: 'a14',
      src: dirAudio + '42_jump.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page030_game0/img/audioOn.png', iconOff: 'games/page030_game0/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 16,
        x: -55,
      },
      width: '67px',
      height: '67px',
      unit: 'px',
    },
  ],
  configGame: configGame,
};

export default dataConfig;
